<template>
  <div>

    <!-- NAVI -->
    <div class="nav-bar" >
      <div class="nav-bar nav-item" >
        <div>
          <p v-bind:class="{ active: selectedNavId == navs[0].id }" @click="selectedNavId = navs[0].id" >{{navs[0].name}}</p>
        </div>
        <div>
          <p v-bind:class="{ active: selectedNavId == navs[1].id }" @click="selectedNavId = navs[1].id" >{{navs[1].name}}</p>
        </div>
      </div>

      <div class="nav-bar nav-logo" >
        <img class="full-height-image" v-bind:src="require('./../assets/images/logos/transparent_logo.png')"  >  
      </div>
      
      <div class="nav-bar nav-item" >
        <div>
          <p v-bind:class="{ active: selectedNavId == navs[2].id }" @click="selectedNavId = navs[2].id" > {{ navs[2].name }} </p>
        </div>
        <div>
          <p v-bind:class="{ active: selectedNavId == navs[3].id }" @click="selectedNavId = navs[3].id" > {{ navs[3].name }} </p>
        </div>
      </div>
    </div>

    <!-- MAIN-PAGE -->
      <!-- HOME -->
    <div v-if="selectedNavId == 0"  class="main-page" > 
      <div class="main-title">
        {{ events[selectedEnevetId-1].title }}
      </div>
      <div class="main-img" >
        <!-- <img class="main-event-img" v-bind:src="require('./../assets/images/logos/hallo.jpg')"  > -->
        <!-- <img class="main-event-img" v-bind:src="require('./../assets/images/logos/hallo.jpg')"  > -->

          <img v-if="events[selectedEnevetId-1].format == 'image' " class="main-event-img" alt="" v-bind:src="require('./../assets/images/logos/' + events[selectedEnevetId-1].img )"  >        
          <video v-else @click="selectedNavItemId = 100" class="main-event-img" playsinline autoplay muted loop >
              <source  v-bind:src="require('./../assets/video/'+ events[selectedEnevetId-1].source )" type='video/mp4'>
          </video>
      </div>
      <div class="main-desc" >
        {{ events[selectedEnevetId-1].text }}
      </div>
      <div class="main-ind inv">
            <div  >
              <Button @click="selectedEnevetId = 1" class="p-button ind-btn" />
              <Button @click="selectedEnevetId = 2" class="p-button-secondary ind-btn" />
              <Button @click="selectedEnevetId = 3" class="p-button-secondary ind-btn" />
            </div>
      </div>
    </div>
      <!-- SYLWESTER -->
    <div v-if="selectedNavId == 1"  class="new-year" >


        <div class="conffetti">

          <div id="conffeti-start-place-1" >

            <ConfettiExplosion  v-if="sideExplode"
                                :particleCount="100"
                                :colors = confettiColors
                                :force=".8"
                                :stageWidth="800"
                                />
          </div>
          <div id="conffeti-start-place-2" >

            <ConfettiExplosion  v-if="sideExplode"
                                :particleCount="100"
                                :colors = confettiColors
                                :force=".8"
                                :stageWidth="800"
                                />
          </div>
          <div id="conffeti-start-place-3" >

            <ConfettiExplosion  v-if="sideExplode"
                                :particleCount="100"
                                :colors = confettiColors
                                :force=".8"
                                :stageWidth="800"
                                />
          </div>

        </div>



        <div class="flip-card">
          <div class="flip-card-inner">
            <div class="flip-card-front">
              <div class="tile front-right">
                
                  <div class="tile outside outside-right">
                    <h2 class="in-card-center card-title front-page">SYLWESTER 2021</h2>
                    <div id="count">
                      <FlipDown
                        :endDate="new Date(2021,12,0)"
                        @timeUp="func"
                        :theme=1
                        :timeUnit ="['Dni','Godziń','Minut', 'Sekund']"
                      />
                    </div>

                    <br>
                    <p class="card-title" > Zabawa z DJ  </p>

                    <p> Stare przeboje <br> przeplatane najnowszymi hitami </p>
                    <p class="card-title">Godzina:
                    </p>
                    <p>20:00-3:00</p>
                    <p class="card-title">Cena:</p>
                    <p style="font-size: 3vh;" >280 zł/os.</p> 
                    <p class="card-title">Miejsce:</p>
                    <p>Sports Pub Gdańsk, ul. Miszewskiego 12/13</p>
                    <br>
                    <br>
                    <h2 style="text-align:center" class="card-title"> ZAJRZYJ DO KARTY </h2>

                  </div>
              </div>
            </div>
            <div class="flip-card-back">
                    <div class="tile inside">
                      <p class="in-card-center card-title title-header">MENU</p>
                      <p class="card-title">Na przywitanie:</p>
                      <div>- sycylijski krem z pomidorów</div>
                      <p class="card-title">Następnie ciepłe dania - od 20:30:</p>
                      <div>- puree ziemniaczane, ziemniaki opiekane</div>
                      <div>- zraz wołowy w sosie własnym </div>
                      <div>- roladki z kurczaka zawijane w boczku </div>
                      <div>- kotlety de volaille z serem </div>
                      <div>- kotlety schabowe </div>
                      <div>- udka z kurczaka w sosie pieczarkowym </div>
                      <div>- bigos staropolski z leśnymi grzybami </div>
                      <p class="card-title">Zimne zakąski:</p>
                      <div>- platery pieczonych mięs </div>
                      <div>- jajka faszerowane łososiem </div>
                      <div>- śledź w sosie musztard., śmiet. oraz oleju </div>
                      <div>- łosoś szefa kuchni </div>
                      <div>- sałatka Cezar z grillowanym kurczakiem </div>
                      <div>- sałatka makaronowa z szynką </div>
                      <div>- sałatka ziemniaczana, zestaw pikli warzywnych </div>
                      <div>- wykwintny pasztet z kaczki z żurawiną </div>
                      <div>- tatar wołowy </div>
                      <div>- galaretka drobiowa </div>
                      <div>- tortilla z kurczakiem </div>
                      <div>- lawasz z warzywami </div>
                      <div>- wybór ciast</div>
                      <p class="card-title">Po północy:</p>
                      <div>- żurek z białą i wędzoną kiełbasą</div>
                      <div>- węgierska zupa gulaszowa </div>
                    </div>
            </div>
          </div>
        </div>


    </div>
      <!-- CONTACT -->
    <div v-if="selectedNavId == 3"  class="main-page" >
      <div class="main-title">
        <p class="active"> Skontaktuj się z nami</p>
      </div>
      <div class="main-img map" >
          <GoogleMap
            :api-key="googleApiKey"
            style="width:100%; height:100%"
            :center="center"
            :zoom="15"
            >
              <Marker :options="{ position: center }" />
          </GoogleMap>
      </div>
      <div class="main-desc" >
          <div>
            <div>
              Księdza Leona Miszewskiego 12/13
              <br> 80-239 Gdańsk

            </div>
            <div>
              Pon. - Czw. 16:00 – 00:00
            </div>
            <div>
              Pt. - Sob. 16:00 – 02:00
            </div>
            <div>
              <i class="pi pi-phone" style="font-size: 1.2vw; margin-right:5%;"/>609 260 113
            </div>
            <div>
              arturzaniewski5@gmail.com
            </div>
          </div>
          <div class="social-media">
            <i class="pi pi-facebook" style="font-size: 2vw; width:33%;float:left;color:#4267B2"/>
            <i class="pi pi-instagram" id="insta" style="font-size: 2vw; width:33%;float:left"/>
            <i class="pi pi-twitter" style="font-size: 2vw; width:33%;float:left;color:#1DA1F2"/>
          </div>
      </div>
    </div>

  </div>
</template>

<script>
import Button from 'primevue/button';
import { GoogleMap, Marker } from 'vue3-google-map';
import ConfettiExplosion from "vue-confetti-explosion";
import FlipDown from 'vue-flip-down';


export default {
  name: 'MainComponent',
  components: {
    Button,
    GoogleMap,
    Marker,
    ConfettiExplosion,
    FlipDown
    
  },
  data () {
    return {
      events:[
        {
          id:1,
          source:"baner_sylwester.mp4",
          format: 'video',
          name:"Błyskoteka",
          text:'Specialnie dla Was, wspólnie \n  z restauracją Rzeźnia  organizujemy \n  niezapomnianą noc Sylwestrową 2021/22 \n\n O oprawę muzyczną zadba DJ Grosheck \n\n O kulinarną rozkosz zadba chef Tomasz \n z restauracji Rzeźnia \n\n  a o %%% Artur ze SportsPubu ',
          title:"SYLWESTER 2021",
          date:"27-11-2022"
        },
        {
          id:2,
          img:"hallo.jpg",
          format: 'image',
          text:"HALLO GRUPOWICZE I KLUBOWICZE\
                *******************************************\
                HALLOWEEN ZBLIŻA SIĘ WIELKIMI KROKAMI I MY JUŻ JESTEŚMY NA NIE GOTOWI.\
                ********************************************\
                MUZYCZNA UCZTA DLA WSZYSTKICH MIŁOŚNIKÓW MUZYCZNYCH KLIMATÓW LAT 90 A PRZY OKAZJI MOJE URODZINY - MAM NADZIEJĘ, ŻE WAS NIE ZABRAKNIE\
                ********************************************\
                WJAZD: 10 ZŁ\
                DRESS CODE: CASUAL ELEGANCE\
                PROMOCJE NA BARZE DO 24:00\
                GODZ 21.00\
                ********************************************",
          title:"WYDARZENIE OKOLICZNOŚCIOWE",
          date:"27-11-2021"
        },
        {
          id:3,
          img:"andrz.jpg",
          format: 'image',
          text:"Witajcie Nasi Wspaniali Klubowicze i Klubowiczki!!!\
                Zapraszamy Was wszystkich na nasze pierwsze Błyskotekowe ANDRZEJKI !!!\
                Tego wieczoru nie zabraknie Magii, Wróżb, Lania Wosku i Fantastycznej Zabawy przy największych Przebojach lat '80 '90 i współczesnych oraz możliwości spędzenia tego czasu ze znajomymi, których czasami przez lata nie mamy okazji spotkać\
                Niezmiennie o muzyczny klimat zadba DJ Grosheck\
                wstęp 20 zł\
                obowiązują stroje eleganckie\
                Nie może Was zabraknąć",

          title:"WYDARZENIE OKOLICZNOŚCIOWE",
          date:"27-11-2021"
        }
      ],
      selectedEnevetId:1,
      navs:[
        {
          id:0,
          name:"Home"
        },
        {
          id:1,
          name:"Sylwester"
        },
        {
          id:2,
          name:"Galeria"
        },
        {
          id:3,
          name:"Kontakt"
        },
      ],
      selectedNavId:0,
      center:{ lat: 54.3770562, lng: 18.6147892 },
      confettiColors:["#C0C0C0" , "#FFD700" ],
      confettiLuncher:[false,false,false],
      sideExplode:false,
      googleApiKey:"AIzaSyACxpy8nOzdjLbIJegWwoOtNVd0cML9kQI"
    }
  },
  mounted() {
    this.startEventInteraval()
  },
  created() {
    this.fireSideConfetti()
  },
  methods: {
    startEventInteraval(){
      this.interval = setInterval(this.nextEvent, 18000)
    },
    fireConffetti(id){
      console.log('dsadsasda', id )
      if(id == 1){
        var vm = this
        setTimeout(() => {
          vm.confettiLuncher[0] = true 
          setTimeout(() => {
            vm.confettiLuncher[1] = true
            vm.confettiLuncher[2] = true 
          }, 200);
        }, 200);


      }else{
          this.confettiLuncher[0] = false 
          this.confettiLuncher[1] = false 
          this.confettiLuncher[2] = false 
      }

    },
    fireSideConfetti(){
      var vm = this

      setInterval(() => {
        vm.sideExplode = true
      }, 3000 );

      setInterval(() => {
        vm.sideExplode = false
      }, 8000 );
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import './../assets/styles/nav.css';
@import './../assets/styles/main.css';
@import './../assets/styles/contact.css';

.conffetti{
    display: flex;
}

#conffeti-start-place-2{
    margin:auto;
}
#conffeti-start-place-3{
    float:right;
}

.new-year{
  margin-top: 7vh;
}
.cards{
  margin:auto;
  width: 80%;
  margin: auto;
}
.card-content{
  background-image: url('./../assets/images/backgrounds/card.jpg');
  background-repeat: round;
  background-size: contain;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
.inside > div{
  font-size:1.3vh;
  text-align: left;
  padding-left:12%;
}
.inside > p,s {
  font-size:1.9vh;
  text-align: center;
  padding-left:0%;
  margin-bottom:1%;
}

.inv{
  display:none;
}

.flip-card {
    background-color: transparent;
    width: 55vh;
    height: 75vh;
    perspective: 10100px;
    margin: auto;
    max-width: 90%;
}

.flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.6s;
  transform-style: preserve-3d;
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
}

.flip-card:hover .flip-card-inner {
  transform: rotateY(180deg);
}

.flip-card-front, .flip-card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  background-image: url('./../assets/images/backgrounds/card.jpg');
  background-repeat: round;
  background-size: contain;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

.flip-card-front {
  color: black;
}

.flip-card-back {
  transform: rotateY(180deg);
}

.outside{
    font-size: 1.9vh;
    text-align: left;
    margin-top: 15%;
    color:#425a6f
}
.card-title{
  font-size: 2.4vh;
  color:rgb(35, 35, 43);
}

.outside > h2 {
  text-align: center;
  font-weight:800;
  padding-left: 0%;
}
.outside > p{
  padding-left: 10%;
  margin: 0% 0% 1% 0%;
}
#count{
  padding-left: 6vw;
}
@media only screen and (max-width: 1200px) {
  .cards{
    width: 90%;
  }
  .card-content{
    width: 80%;
    min-height: 70vh
  }

}

@media only screen and (max-width: 600px) {
  .cards{
    width: 90%;
  }
  .card-content{
    width: 100%;
    min-height: 70vh
  }
  .inside > p,s {
    font-size:2.1vh;
    text-align: center;
    padding-left:0%;
    margin-bottom:1%;
  }
  .inside > div{
    font-size:2.2vw;
    text-align: left;
    padding-left:12%;
  }

}


</style>
